import { Notify } from '@shared/ui-native/Notify';


export function isTabInFocus() {
    // assume it has focus if the browser doesn't support document.hasFocus()
    let focus = true;
    if (document.hasFocus && !document.hasFocus()) {
        focus = false;
    }
    return focus;
}

export function downloadURL(url: string) {
    //window.open(data.url, '_blank'); old way that triggers popup blocker, window.location works but will break with broken download links

    const iframe = $('<iframe style="display: none">');
    iframe.attr('src', url).appendTo('body');

    iframe.load(() => {
        const iframeTitle = iframe.contents().find('title').html() || '';
        if (iframeTitle.toLowerCase().indexOf('error') > -1) {
            Notify.error();
        }
    });

    setTimeout(() => {
        iframe.remove();
    }, 20000);
}

export function getFilenameWithVersion(item: { name: string, version?: number, latestVersion?: number }): string {
    if (item.hasOwnProperty('version') && item.hasOwnProperty('latestVersion')) {
        if (item.version !== item.latestVersion) {
            return `${item.name} (v${item.version + 1}/${item.latestVersion + 1})`;
        }
    }

    return item.name;
}

/**
 * Decodes only ampersand HTML entities (&amp;) in a string for display in React components.
 * The backend HTML-encodes names for safe innerHTML usage in the Tree component,
 * but React's JSX text interpolation displays entities literally.
 * Only ampersand is decoded to allow names like "Tom & Jerry" while keeping
 * other entities like &lt; and &gt; encoded for safety.
 */
export function decodeHtmlEntities(str: string): string {
    if (!str) return str;
    return str.replace(/&amp;/g, '&');
}


export function splitAuthStringFromURL(url: string) {
    if (url == null) {
        return [null, null];
    }

    const regEscape = v => v.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, ''); /* disallows special characters in keys */
    const keys = ["token", "authkey", "accesskey"]; /* if new kind of authentication key is encountered, add it to this list */

    let key;
    let tokenParts;

    for (let i = 0; i < keys.length; i++) {
        key = keys[i];
        tokenParts = url.split(new RegExp(regEscape(key+'='), "ig")); /* splits the URL case-insensitively */
        if (tokenParts.length >= 2) {
            const caseSensitiveKey = RegExp(key, "ig");
            key = url.match(caseSensitiveKey)[0] /* assigns the key to be in same case as in the URL */
            break;
        }
        else if (i === keys.length-1) {
            /* console.log("The URL's (%s) authentication method is not currently supported. Only '%s' are supported.", url, keys); */
            return [null, null];
        }
    }

    const tokenWithoutLaterParams = tokenParts[1].split('&');

    return [key , tokenWithoutLaterParams[0]] ;
}

export function removeStateFromUrl(): void {
    if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', location.origin + location.pathname);
    }
}


export const countsIncludesModels = (counts: LayerCounts) => {
    return counts.triangleMeshes > 0
    || counts.features > 0
    || counts.stringlines > 0
    || counts.breaklineLayers > 0
    || counts.pointsLayers > 0
}


export const isCrashProneMobile = () => {
    return window.innerWidth < 900;
}

export const roundAndPad = (num: number, precision: number) => {
    const rounded = Number(num.toFixed(precision));
    return rounded.toFixed(precision);
}

export function isModel(filename: string) {
    return (/dxf|dwg|lin|gt|geo|kof|prf|xml|ini|nfcl|zip|ifc/i.test(utils.getExtensionFromFilename(filename)));
}
